import { render } from "./Highlights.vue?vue&type=template&id=c0f00012&scoped=true"
import script from "./Highlights.vue?vue&type=script&lang=js"
export * from "./Highlights.vue?vue&type=script&lang=js"

import "./Highlights.vue?vue&type=style&index=0&id=c0f00012&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0f00012"]])

export default __exports__